import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert } from "../../../js/ComponentManager";
/* 개발담당:양유빈
 * 화면기능:상품등록 > 소재선택
 * 세부설명:
*/

export class MaterialReg extends Component {
    static displayName = MaterialReg.name;

    constructor(props) {
        super(props);
        this.state = {
            Title:"",
            GoodsMatal:[]
        };
        this.handleMaterial_Clik = this.handleMaterial_Clik.bind(this);
        this.handleMaterialSelect_Clik = this.handleMaterialSelect_Clik.bind(this);
    }
    GoodsDataSetProp = {
        GoodsMatalModel: [],
        GoodsMatalInfo: null
        
    }
    //초기화
    componentDidMount() {
        if (this.props.ContentState !== undefined && this.props.ContentState !== null) {
            this.GoodsDataSetProp.GoodsMatalInfo = Big3Common.Util.Cloen(this.props.ContentState.GoodsMatalInfo);
        }
        this.MaterialCodeDataCall();
    }
    async MaterialCodeDataCall() {
        try {
            //색상코드 012
            const mstCd = "013";
            let Data = await Big3Common.Get(`api/Common/BaseCode/GetCommonCode/${mstCd}`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.dataTable);
                this.setState({ GoodsMatal: DataList });
            }
            else {
                console.log("등록된 데이터가 없습니다.");
            }
        }
        catch (e) {
            console.log("MaterialCodeDataCall: ", e)
        }
        return false;
    }  
    //소재선택
    handleMaterial_Clik(event, MatalCd, MatalNm) {
        if (this.GoodsDataSetProp.GoodsMatalModel.length > 3) {
            this.setState({ Title: "소재 선택은 최대 4개입니다." });
            Big3Common.ModalAlert(bootstrap, 'MaterialAlert');
            return false;
        }
        document.querySelectorAll(".Material_Category > .category_item").forEach((sizeElement) => {
            if (sizeElement.id === MatalCd) {
                if (sizeElement.className === "category_item col") {
                    sizeElement.className = "category_item col select";

                    let goodsmatalinfo = Big3Common.Util.Cloen(this.GoodsDataSetProp.GoodsMatalInfo);
                    goodsmatalinfo.Matal_Cd = MatalCd;
                    goodsmatalinfo.Matal_Nm = MatalNm;
                    this.GoodsDataSetProp.GoodsMatalModel.push(goodsmatalinfo);
                }
                else {
                    sizeElement.className = "category_item col";
                    //선택된 항목 삭제
                    Big3Common.Util.RemoveModelListRow(this.GoodsDataSetProp.GoodsMatalModel, "Matal_Cd", MatalCd);
                }
            }
        });
        event.preventDefault();
    }
    handleMaterialSelect_Clik(event) {
        if (this.GoodsDataSetProp.GoodsMatalModel.length === 0) {
            this.setState({ Title: "소재를 선택하여 주세요." });
            Big3Common.ModalAlert(bootstrap, 'MaterialAlert');
            return false;
        }

        let ContentState = this.props.ContentState;
        ContentState.GoodsMatalModel = this.GoodsDataSetProp.GoodsMatalModel;
        this.props.RenderComponent('MaterialDtl', ContentState);
        event.preventDefault();
    }
    render() {
        let ListData = this.state.GoodsMatal;
        return (
            <div>
                <div className="Material_wrap">
                    <div className="category_slectbox">
                        <div className="title">소재선택</div>
                        <div className="category_select Material_Category row row-cols-2">
                            {ListData.map(list =>
                                <div className="category_item col"
                                    key={list.dtl_cd}
                                    id={list.dtl_cd}
                                    onClick={(e) => this.handleMaterial_Clik(e, list.dtl_cd, list.dtl_nm)}>{list.dtl_nm}
                                </div>
                            )}
                        </div>
                    </div>

                </div>
                <div className="catagory_button_box">
                    <button type="button" className="btn_v btn_v1" onClick={this.handleMaterialSelect_Clik}>혼용률 입력하기</button>
                </div>
                <Alert
                    id="MaterialAlert"
                    title={this.state.Title}
                />
            </div>
        );
    }
}
